import { MessageService } from 'primeng/api';
import { Component, inject, computed, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { BlockUIModule } from 'primeng/blockui';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BarraSuperiorComponent } from './componentes/barra-superior/barra-superior.component';
import { ButtonModule } from 'primeng/button';
import { AuthStore, AuthStoreType, SocketStatus } from './stores/auth.store';
import { ThemeStore } from './stores/theme.store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    ToastModule,
    BlockUIModule,
    ConfirmDialogModule,
    BarraSuperiorComponent,
    ButtonModule,
  ],
})
export class AppComponent {
  public mensaje = '';

  authStore: AuthStoreType = inject(AuthStore);

  bloquearPantalla = computed(
    () => this.authStore.blockuiActivo() || this.authStore.socketStatus() !== SocketStatus.Connected
  );
  themeStore: InstanceType<typeof ThemeStore> = inject(ThemeStore); // Forzar inicialización del ThemeStore
  private analyticsService = inject(AnalyticsService);
  private deviceService: DeviceDetectorService = inject(DeviceDetectorService);
  messageService: MessageService = inject(MessageService); // Público para uso en template
}
